import FieldBlock from "../../components/CreateClaim/FieldBlock";
import { FileClaimSteps } from "./types";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RootState } from "../../store/root-reducer";
import { renderPDFImage } from "../../helper";

function ReviewDetails() {
  const { t } = useTranslation();
  const claim = useSelector((state: RootState) => state.claim);

  return (
    <div className="space-y-5">
      <div className="bg-[#F3F8FE] bg-opacity-80 min-h-8  p-4 border-border-gray  border  gap-2 overflow-hidden rounded-lg">
        <p className="text-black font-semibold text-lg">
          {t(FileClaimSteps.CUSTOMER_INFO)}
        </p>
        <div className="space-y-2 mt-2">
          <FieldBlock
            label="First Name"
            value={claim.customerInfo.first_name}
          />
          <FieldBlock label="Last Name" value={claim.customerInfo.last_name} />
          <FieldBlock label="Email" value={claim.customerInfo.email} />
          <FieldBlock label="Mobile Number" value={claim.customerInfo.number} />
          <FieldBlock label="Address 1" value={claim.customerInfo.address1} />
          <FieldBlock label="Address 2" value={claim.customerInfo.address2} />
          <FieldBlock label="City" value={claim.customerInfo.city} />
          <FieldBlock label="State" value={claim.customerInfo.state} />
          <FieldBlock label="Zip" value={claim.customerInfo.zip} />
        </div>
      </div>
      <div className="bg-[#F3F8FE] bg-opacity-80 min-h-8  p-4 border-border-gray  border  gap-2 overflow-hidden rounded-lg">
        <p className="text-black font-semibold text-lg">
          {t(FileClaimSteps.PURCHASE_INFO)}
        </p>
        <div className="space-y-2 mt-2">
          <FieldBlock
            label="Store of Purchase"
            value={claim.purchaseInfo.store_purchase}
          />
          <FieldBlock
            label="Invoice Number"
            value={claim.purchaseInfo.invoice_number}
          />
          <FieldBlock
            label="Retailer Phone"
            value={claim.purchaseInfo.retailer_phone}
          />
          <FieldBlock label="Address 1" value={claim.purchaseInfo.address1} />
          <FieldBlock label="Address 2" value={claim.purchaseInfo.address2} />
          <FieldBlock label="City" value={claim.purchaseInfo.city} />
          <FieldBlock label="State" value={claim.purchaseInfo.state} />
          <FieldBlock label="Zip" value={claim.purchaseInfo.zip} />
          <FieldBlock
            label="Purchase Date"
            value={claim.purchaseInfo.purchase_date}
          />
          <FieldBlock
            label={"Copy of your invoice"}
            value={claim.purchaseInfo.invoice_image}
            image
          />
        </div>
      </div>
      <div className="bg-[#F3F8FE] bg-opacity-80 min-h-8  p-4 border-border-gray  border  gap-2 overflow-hidden rounded-lg">
        <p className="text-black font-semibold text-lg">
          {t(FileClaimSteps.DAMAGE_INFO)}
        </p>
        <div className="space-y-2 mt-2">
          <FieldBlock
            label="Date of Incident"
            value={claim.damageInfo.date_incident}
          />
          <FieldBlock
            label="Product Type"
            value={claim.damageInfo.product_type}
          />
          <FieldBlock
            label="Did you clean the product?"
            value={claim.damageInfo.did_clean_product}
          />

          {["protector", "encasement"].includes(
            claim?.damageInfo?.product_type?.toLowerCase()
          ) && (
            <>
              <FieldBlock
                label="Protector/Encasement Stained/Damaged"
                value={claim.damageInfo.protector_damage}
              />
              {claim.damageInfo.protector_damage
                .toLowerCase()
                .includes("yes") && (
                <FieldBlock
                  label="Type of Stain/Damage (Protector)"
                  value={claim.damageInfo.damage_Protector_type}
                />
              )}
            </>
          )}

          <FieldBlock
            label="Mattress Stained/Damaged"
            value={claim.damageInfo.mattress_stained_damaged}
          />
          {claim.damageInfo.mattress_stained_damaged
            .toLowerCase()
            .includes("yes") && (
            <>
              <FieldBlock
                label="Type of Mattress Stain/Damage"
                value={claim.damageInfo.type_of_stain_damage}
              />
              <FieldBlock
                label="Estimated Mattress Retail Value (USD)"
                value={`$${claim.damageInfo.estimated_retail_value}`}
              />
              <FieldBlock
                label="Mattress Manufacturer"
                value={claim.damageInfo.mattress_manufacturer}
              />
              <FieldBlock
                label="Mattress Model"
                value={claim.damageInfo.mattress_model}
              />
              <FieldBlock
                label="Mattress Size"
                value={claim.damageInfo.mattress_product}
              />
              <FieldBlock
                label="Was the Protector/Encasement on bed during incident?"
                value={claim.damageInfo.protector_on_bed}
              />
            </>
          )}

          <FieldBlock
            label="Product Size"
            value={claim.damageInfo.product_size}
          />
          <FieldBlock
            label="Damage Notes"
            value={claim.damageInfo.damageNotes}
          />
        </div>
      </div>
      <div className="bg-[#F3F8FE] bg-opacity-80 min-h-8  p-4 border-border-gray  border  gap-2 overflow-hidden rounded-lg">
        <p className="text-black font-semibold text-lg">{t("Documents")}</p>
        <div className="space-y-3 mt-2">
          {claim?.documents?.protector_damage_images?.length > 0 && (
            <div>
              <p className="font-medium text-black text-sm">
                {t("Three (3) photos of the stained or damaged product")}
              </p>
              <div className="flex items-center gap-4 mt-1 flex-wrap">
                {claim.documents.protector_damage_images.map(renderPDFImage)}
              </div>
            </div>
          )}
          {claim.damageInfo.mattress_stained_damaged &&
            claim.documents.mattress_damage_images.length > 0 && (
              <div>
                <p className="font-medium text-black text-sm">
                  {t("Three (3) photos of the stained or damaged mattress")}
                </p>
                <div className="flex items-center gap-4 mt-1 flex-wrap">
                  {claim.documents.mattress_damage_images.map(renderPDFImage)}
                </div>
              </div>
            )}
          {claim?.documents?.protectall_tag_image && (
            <div>
              <p className="font-medium text-black text-sm">
                {t("ProtectALL Product Tag Photo")}
              </p>
              {renderPDFImage(claim?.documents?.protectall_tag_image)}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ReviewDetails;
